import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { GalleryDto, GalleryTheme } from '@nusign/picflow-backend-types';
import { loadFont } from '../../../lib/load-font';
import { ApplyTypographyStylesDirective } from '../../directives/apply-typography-styles.directive';
import { CoverDesignComponent } from '../cover-design/cover-design.component';

@Component({
  selector: 'app-theme-item',
  imports: [ApplyTypographyStylesDirective, CoverDesignComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-item.component.html',
  styleUrl: './theme-item.component.scss',
  host: { '[style.background-color]': 'theme().layout_page.background_color' },
})
export class ThemeItemComponent {
  theme = input.required<GalleryTheme>();
  customTitle = input<string>();
  gallery = input.required<GalleryDto>();

  constructor() {
    effect(() => {
      const theme = this.theme();
      if (!theme) return;

      const fonts = new Set<string>();
      fonts.add(theme.cover.title_typography.font_family);
      // fonts.add(theme.cover.paragraph_typography.font_family);
      fonts.add(theme.section.title_typography.font_family);
      fonts.add(theme.section.paragraph_typography.font_family);

      fonts.forEach(font => {
        if (font) {
          loadFont(font);
        }
      });
    });
  }
}
